import { CardModuleProps } from './@types'
import { Edit } from './edit'
import { View } from './view'

export function CardModule({
  module,
  className,
  variant = 'view',
  editProps,
  ...props
}: CardModuleProps) {
  if (variant === 'edit' && editProps)
    return (
      <Edit
        label={editProps.label}
        onIconFileChange={editProps.onIconFileChange}
        defaultFile={editProps.defaultFile}
      />
    )

  return <View {...props} module={module} className={className} />
}
